import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { useAxiosLoader } from './plugins/axios'
import LoadingOverlay from 'react-loading-overlay-ts';
import BeatLoader from 'react-spinners/BeatLoader';
import { HashRouter } from 'react-router-dom';
import { hotjar } from 'react-hotjar';
import { HotjarId } from './constants/provider/constant';
import {fetchUserDetailsAndSetUserForAnalytics} from './helper/events'
import {EVENT_COLLECTOR_URL} from "./event-constant"
import UserFeaturesProvider from './hook/UserDetails/UserFeaturesProvider';
const GlobalLoader = () => {
  const [loading] = useAxiosLoader();
  useEffect(() => {
    hotjar.initialize(HotjarId,6)
  },[])

  useEffect(() => {
    const loadSnowplowScript = () => {
      const loadScript = (id, content, defer = false) => {
        const script = document.createElement('script');
        script.id = id;
        script.defer = defer;
        script.innerHTML = content;
        script.onerror = () => console.error(`${id} failed to load.`);
        script.onload = () => console.log(`${id} loaded successfully.`);
        document.head.appendChild(script);
      };

      const scripts = [
        {
          id: 'snowplow-script',
          content: `(function (p, l, o, w, i, n, g) {
            if (!p[i]) {
              p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
              p.GlobalSnowplowNamespace.push(i);
              p[i] = function () {
                (p[i].q = p[i].q || []).push(arguments);
              };
              p[i].q = p[i].q || [];
              n = l.createElement(o);
              g = l.getElementsByTagName(o)[0];
              n.async = 1;
              n.src = w;
              g.parentNode.insertBefore(n, g);
            }
          })(
            window,
            document,
            'script',
            'https://unpkg.com/@snowplow/javascript-tracker@3.15.0/dist/sp.js',
            'snowplow'
          );

          window.snowplow(
            'newTracker',
            'snow-plow-tracker',
            '${EVENT_COLLECTOR_URL}',
            {
              appId: 'web-events-manager',
              platform: 'web',
              discoverRootDomain: true,
              cookieSameSite: 'Lax',
            }
          );
          
          window.snowplow('trackPageView');`
        }
      ];

      scripts.forEach(({ id, content, defer }) => {
        if (content) loadScript(id, content, defer);
      });
    };
    loadSnowplowScript();
    fetchUserDetailsAndSetUserForAnalytics();
  }, []);
  return(
    <React.StrictMode>
      <LoadingOverlay active={loading} spinner={<BeatLoader color={'#042e43'}/>} styles={
          {
            overlay: (base) => ({
            ...base,
            height:'100%',
            background: 'rgba(211,211,211, 0.5)' })
          }
        }>
        <UserFeaturesProvider>
        <App />
        </UserFeaturesProvider>
      </LoadingOverlay>
    </React.StrictMode>
  );
}

ReactDOM.render(
  <HashRouter>
    <GlobalLoader />
  </HashRouter>,
  document.getElementById('root')
);

